// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const housingType = "PropertyForm__housingType__WivQo";
export const innerForm = "PropertyForm__innerForm__Wc6+b";
export const medium = "500";
export const radioBox = "PropertyForm__radioBox__btK6m";
export const radioButton = "PropertyForm__radioButton__9zssZ";
export const radioColumn = "PropertyForm__radioColumn__typd7";
export const radioLabel = "PropertyForm__radioLabel__U21JM";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";